<template>
    <div class="user-k"></div>
</template>

<script>
import { SELL_ICON_ECHART, BUY_ICON_ECHART, FLAG_ECHART } from "@/utils/constant";
import { isArray } from "@/utils/common";

export default {
    props: {
        chartData: {
            default: ''
        }
    },
    data: function () {
        return {
            myChart: '',
            chartSetting: {
                width: '100%',
                height: 300,
                splitLineColor: '#3f3f40',
                colorList: ['#17966d'],
                textColor: '#a8a7a9'
            }
        }
    },
    watch: {
        chartData: function (){
            if (this.myChart) {
                this.myChart.clear();
            }
            this.initChart();
        }
    },
    mounted() {
        if (this.chartData) {
            this.initChart();
        }
    },
    methods: {
        // chart 初始化
        initChart() {
            this.myChart = this.$echarts.init(this.$el);
            let market_data = this.getMarketPoint();
            var min_data = Math.min.apply(null, this.chartData.market)-10;

            // chart 配置
            let options = {
                tooltip: {
                    axisPointer: {
                        type: 'cross',
                    },
                    trigger: 'axis',
                },
                color: this.chartSetting.colorList,
                textStyle: {
                    color: this.chartSetting.textColor
                },
                dataZoom: [{
                    type: 'inside',
                    xAxisIndex: [0],
                    start: 0,
                    end: 100
                }],
                grid: [
                    {x: 60, y: 30, width: '90%', height: this.chartSetting.height}
                ],
                xAxis: [
                    {
                        gridIndex: 0, type: 'category', data: this.chartData.createtime,
                        show: true, borderColor: '#a8a7a9'
                    }
                ],
                yAxis: [
                    {
                        // position: 'right',
                        name: '交易价格',
                        gridIndex: 0,
                        type: 'value',
                        axisLabel: {
                            formatter: "{value}",
                        },
                        splitLine: {
                            lineStyle: {
                                color: this.chartSetting.splitLineColor
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: this.chartSetting.splitLineColor
                            }
                        },
                        min: min_data,
                    }
                ],
                series: [
                    {
                        type: 'line',
                        name: '交易价格',
                        data: this.chartData.market,
                        xAxisIndex: 0,
                        yAxisIndex: 0,
                        symbol: 'none',
                        lineStyle: {
                            width: 2
                        },
                        markPoint: {
                            symbolSize: [6, 10],
                            data: market_data
                        }
                    }
                ]
            };

            this.myChart.setOption(options);
        },

        // 计算 markpoint 
        getMarketPoint() {
            let direction_down_data = this.chartData.down_direction;
            let direction_up_data = this.chartData.up_direction;
            let market_data = this.chartData.market;
            let that = this;
            let market_arr = [];

            if (isArray(direction_down_data)) {// 下半组
                direction_down_data.forEach((value, index) => {
                    var color, symbol;
                    var obj = {
                        coord: [index, market_data[index]+1],
                        name: '交易信号',
                        symbolOffset: [0, '70%'],
                    };

                    if (value > 0) {// 买
                        color = 'rgba(185, 164, 44, 0.8)';
                        symbol = BUY_ICON_ECHART;
                    } else if (value < 0) {
                        // color = '#db5634';
                        color = 'rgba(219, 86, 52, 0.7)';
                        symbol = SELL_ICON_ECHART;
                    };
                    if (value !== 0) {
                        obj['itemStyle'] = { color: color };
                        obj['symbol'] = symbol;
                        market_arr.push(obj);
                    }
                })
            };

            if (isArray(direction_up_data)) {// 上半组
                direction_up_data.forEach((value, index) => {
                    var color, symbol;
                    var obj = {
                        coord: [index, market_data[index]+1],
                        name: '交易信号',
                        symbolOffset: [0, '-70%'],
                    };

                    if (value > 0) {// 买
                        color = 'rgba(185, 164, 44, 0.8)';
                        symbol = BUY_ICON_ECHART;
                    } else if (value < 0) {
                        color = 'rgba(219, 86, 52, 0.7)';
                        symbol = SELL_ICON_ECHART;
                    };
                    if (value !== 0) {
                        obj['itemStyle'] = { color: color };
                        obj['symbol'] = symbol;
                        market_arr.push(obj);
                    };
                })
            };

            market_arr.push({
                name: '最大值',
                type: 'max',
                symbolOffset: ['-12', '0'],
                symbol: FLAG_ECHART,
                symbolSize: [10, 15],
                itemStyle: {color: '#fff'},
                symbolRotate: 90,
                label: {offset: [-40, 0], formatter: (params) => {
                    return params.value.toFixed(4);
                }}
            });
            market_arr.push({
                name: '最小值',
                type: 'min',
                symbolOffset: ['15', '0'],
                symbol: FLAG_ECHART,
                symbolSize: [10, 15],
                itemStyle: {color: '#fff'},
                symbolRotate: 270,
                label: {offset: [40, 0], formatter: (params) => {
                    return params.value.toFixed(4);
                }}

            })
            return market_arr;
        },

        // echart loading 事件
        chartLoadingEvent(flag) {
            if (!this.myChart) return;
            if (flag == 'show') {
                this.myChart.showLoading({
                    maskColor: 'rgba(0, 0, 0, 0.8)',
                    text: 'loading...',
                    textColor: '#999'
                });
            } else if (flag == 'hide') {
                this.myChart.hideLoading();
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .user-k {
        height: 350px;
        width: 100%;
    }
</style>
